import { render } from "./ProfileCover.vue?vue&type=template&id=aa29ff58&ts=true"
import script from "./ProfileCover.vue?vue&type=script&lang=ts"
export * from "./ProfileCover.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__